import React, {memo} from 'react';
import cn from 'classnames';
import {AdBanner} from '@/app/components/common/advertising';
import {useRoute} from '@/common/services/router';
import {AnyRouteResult} from '@/app/interfaces/routing';
import {RouteName} from '@/app/constants/routing';
import styles from './AppBanners.css';

export const AppBanners = memo(() => {
	const {route} = useRoute<AnyRouteResult>();

	if (route.name === RouteName.notFound) {
		return <div className={styles.root} />;
	}

	return (
		<div className={styles.root}>
			<AdBanner interfaceName='desktop' zoneName='topWide' placeholder />
			<AdBanner
				className={cn(styles.sideBanner, styles.isLeft)}
				interfaceName='desktop'
				zoneName='verticalSideLeft'
			/>
			<AdBanner
				className={cn(styles.sideBanner, styles.isRight)}
				interfaceName='desktop'
				zoneName='verticalSideRight'
			/>
		</div>
	);
});

AppBanners.displayName = 'AppBanners';
